(() => {
  const selector = '.card-gallery slideshow-component[infinite]';
  const gestures = new Map();
  const touchGestures = new Map();
  const wheelCooldowns = new WeakMap();
  const minimumSwipeDistance = 40;
  let normalizationFrame = 0;

  const normalizeSlides = () => {
    for (const slideshow of document.querySelectorAll(selector)) {
      if (slideshow.getAttribute('disabled') === 'true') continue;

      const variantSlides = new Set(
        slideshow.querySelectorAll('slideshow-slide[variant-image]')
      );
      if (variantSlides.size === 0) continue;

      for (const slide of slideshow.querySelectorAll('slideshow-slide')) {
        if (variantSlides.has(slide)) {
          slide.removeAttribute('hidden');
          slide.removeAttribute('variant-image');
        } else {
          slide.setAttribute('hidden', '');
          slide.setAttribute('aria-hidden', 'true');
        }
      }
    }
  };

  const scheduleSlideNormalization = () => {
    if (normalizationFrame) return;

    normalizationFrame = requestAnimationFrame(() => {
      normalizationFrame = 0;
      normalizeSlides();
    });
  };

  normalizeSlides();

  new MutationObserver(scheduleSlideNormalization).observe(document.body, {
    childList: true,
    subtree: true,
  });

  const getState = (slideshow) => {
    const slides = Array.from(
      slideshow.querySelectorAll('slideshow-slide:not([hidden])')
    );

    return {
      currentIndex: slides.findIndex(
        (slide) => slide.getAttribute('aria-hidden') === 'false'
      ),
      lastIndex: slides.length - 1,
    };
  };

  const clickArrow = (slideshow, direction) => {
    const ref = direction === 'forward' ? 'next' : 'previous';
    const arrow = slideshow.querySelector(`[ref="${ref}"]`);

    if (arrow instanceof HTMLButtonElement) {
      arrow.click();
    }
  };

  const completeSwipe = (
    slideshow,
    startX,
    endX,
    startedAtStart,
    startedAtEnd
  ) => {
    if (!slideshow || !slideshow.isConnected) return;

    const distance = startX - endX;

    if (Math.abs(distance) < minimumSwipeDistance) return;

    if (startedAtEnd && distance > 0) {
      requestAnimationFrame(() => {
        clickArrow(slideshow, 'forward');
      });
    } else if (startedAtStart && distance < 0) {
      requestAnimationFrame(() => {
        clickArrow(slideshow, 'backward');
      });
    }
  };

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (event.pointerType === 'touch') return;
      if (!(event.target instanceof Element)) return;

      const slideshow = event.target.closest(selector);
      if (!slideshow) return;

      const { currentIndex, lastIndex } = getState(slideshow);

      gestures.set(event.pointerId, {
        slideshow,
        startX: event.clientX,
        startedAtStart: currentIndex === 0,
        startedAtEnd: currentIndex === lastIndex,
      });
    },
    true
  );

  document.addEventListener(
    'pointerup',
    (event) => {
      if (event.pointerType === 'touch') return;

      const gesture = gestures.get(event.pointerId);
      gestures.delete(event.pointerId);

      if (!gesture) return;

      completeSwipe(
        gesture.slideshow,
        gesture.startX,
        event.clientX,
        gesture.startedAtStart,
        gesture.startedAtEnd
      );
    },
    true
  );

  document.addEventListener(
    'pointercancel',
    (event) => {
      gestures.delete(event.pointerId);
    },
    true
  );

  document.addEventListener(
    'touchstart',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const slideshow = event.target.closest(selector);
      if (!slideshow) return;

      const touch = event.changedTouches[0];
      if (!touch) return;

      const { currentIndex, lastIndex } = getState(slideshow);

      touchGestures.set(touch.identifier, {
        slideshow,
        startX: touch.clientX,
        startedAtStart: currentIndex === 0,
        startedAtEnd: currentIndex === lastIndex,
      });
    },
    {
      capture: true,
      passive: true,
    }
  );

  document.addEventListener(
    'touchend',
    (event) => {
      for (const touch of event.changedTouches) {
        const gesture = touchGestures.get(touch.identifier);
        touchGestures.delete(touch.identifier);

        if (!gesture) continue;

        completeSwipe(
          gesture.slideshow,
          gesture.startX,
          touch.clientX,
          gesture.startedAtStart,
          gesture.startedAtEnd
        );
      }
    },
    {
      capture: true,
      passive: true,
    }
  );

  document.addEventListener(
    'touchcancel',
    (event) => {
      for (const touch of event.changedTouches) {
        touchGestures.delete(touch.identifier);
      }
    },
    {
      capture: true,
      passive: true,
    }
  );

  document.addEventListener(
    'wheel',
    (event) => {
      if (!(event.target instanceof Element)) return;
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      if (Math.abs(event.deltaX) < 10) return;

      const slideshow = event.target.closest(selector);
      if (!slideshow || wheelCooldowns.get(slideshow)) return;

      const { currentIndex, lastIndex } = getState(slideshow);
      const loopForward = currentIndex === lastIndex && event.deltaX > 0;
      const loopBackward = currentIndex === 0 && event.deltaX < 0;

      if (!loopForward && !loopBackward) return;

      wheelCooldowns.set(slideshow, true);
      clickArrow(slideshow, loopForward ? 'forward' : 'backward');

      setTimeout(() => {
        wheelCooldowns.delete(slideshow);
      }, 500);
    },
    {
      capture: true,
      passive: true,
    }
  );
})();
